import useAuth from "hooks/useAuth";
import { useTranslation } from "react-i18next";
import { DashboardData } from "services/dashboardService";
import { getCurrencySymbol, toCurrency, toDecimal } from "utils/format";
import { cn } from "utils/styles";

type Props = {
  variant?: "primary" | "secondary";
  data: DashboardData;
};

export const InvestedCard = ({
  variant = "primary",
  data,
}: Props) => {
  const { t, i18n } = useTranslation();
  const { selectedProvider } = useAuth();

  return (
    <div
      className={cn(
        "rounded-2xl flex-1",
        variant === "primary"
          ? "bg-primaryMultiply/70 pt-7 pb-5 px-7 min-h-40"
          : "border-white/30 border py-2 px-4 flex flex-col justify-center min-h-48"
      )}
    >
      <div
        className={cn(
          "flex items-center justify-center tablet:justify-start",
          variant === "primary" ? "gap-2.5" : "gap-1"
        )}
      >
        <img
          className={cn(variant === "primary" ? "" : "h-3.5")}
          src="/icons/campaigns/invested.svg"
          alt=""
        />
        <p className={cn(variant === "primary" ? "" : "text-xs")}>
          {t("dashboard.cards.resume")}
        </p>
      </div>
      <div
        className={cn(
          "flex flex-col tablet:flex-row items-center tablet:items-start justify-between font-input",
          variant === "primary" ? "mt-2 desktop:mt-5 gap-4" : "mt-1 gap-2"
        )}
      >
        <div className="flex flex-col items-center tablet:items-start">
          <p className="text-secondary text-xs">
            {t("dashboard.cards.totalInvested")}
          </p>
          <p
            className={cn(
              "font-bold",
              variant === "primary" ? "text-xl desktop-lg:text-2xl" : "text-lg"
            )}
          >
            <span className="text-sm">
              {getCurrencySymbol(selectedProvider.currency, i18n.language)}
            </span>
            {toCurrency(data.total.invested, i18n.language, selectedProvider.currency)}
          </p>
          <p className="text-secondary text-xs">
            <span className="text-xs">
              {getCurrencySymbol(selectedProvider.currency, i18n.language)}
            </span>
            {toCurrency(
              data.total.dailyInvested,
              i18n.language,
              selectedProvider.currency
            )}
            /{t("dashboard.cards.day")}
          </p>
        </div>
        <div>
          <p className="text-secondary text-xs">
            {t("dashboard.cards.totalLeads")}
          </p>
          <p
            className={cn(
              "font-bold text-center tablet:text-start",
              variant === "primary" ? "text-xl desktop-lg:text-2xl" : "text-lg"
            )}
          >
            {data.total.leads}
          </p>
          <p className="text-secondary text-xs text-center tablet:text-start">
            {toDecimal(data.total.dailyLeads, i18n.language, selectedProvider.currency)}/{t("dashboard.cards.day")}
          </p>
        </div>
      </div>
    </div>
  );
};
